import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled/macro';

const GroupedTableCell = ({
  content,
  className,
  isFirstCellEmpty = false,
  isPercentage = false,
}) => {
  let validatedContent = content ? content : '-';

  if (isFirstCellEmpty) {
    validatedContent = '';
  }
  return (
    <td className={className} data-testid="grouped-table-cell">
      {validatedContent}
      {isPercentage && '%'}
    </td>
  );
};

GroupedTableCell.propTypes = {
  isFirstCellEmpty: PropTypes.bool,
  isPercentage: PropTypes.bool,
};

const StyledGroupedTableCell = styled(GroupedTableCell)``;

export default StyledGroupedTableCell;
